module.exports = __webpack_public_path__ + "static/media/4wd-engaged.92d3617e.svg";